import React, { useEffect } from 'react'

import ProfileSettings from '../components/Settings/ProfileSettings'
import { useAppLayoutResetter } from '@caudena/core/state'

export const PageProfileSettings = () => {
  const resetLayout = useAppLayoutResetter()
  useEffect(() => {
    resetLayout()
  }, [])
  return <ProfileSettings />
}

export default PageProfileSettings
